<ng-container *ngIf="!!element?.quiz_uuid">
  <div
    class="flex w-full justify-center rounded-tl-2xl bg-white px-10 pt-10 shadow-xl"
    [ngClass]="{
      'rounded-tr-2xl': fullWidth || fullSize,
      'rounded-bl-2xl rounded-br-2xl': fullSize,
      'pb-10': paddingBottom
    }"
  >
    <button
      app-button
      (click)="onOpenQuiz(element.quiz_uuid, elementInfo?.trail?.slug, elementInfo?.evento_id, element.slug)"
      class="bg-blue-400 font-semibold text-white"
      translate
    >
      gestor-avaliacoes.iniciar
    </button>
  </div>
</ng-container>
